import { Box, Popover, Text } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'

import { type CoreInquiry } from '@flecto/types'
import { Badge } from '@flecto/ui'

export type BadgeInquiryStatusProps = {
  inquiry?: CoreInquiry
}

export function BadgeInquiryCustomer({ inquiry }: BadgeInquiryStatusProps) {
  const [opened, { close, open }] = useDisclosure(false)

  if (!inquiry?.customer) {
    return null
  }

  return (
    <Popover opened={opened}>
      <Popover.Target>
        <Box onMouseEnter={open} onMouseLeave={close}>
          <Badge color='green'>{inquiry.customer.full_name}</Badge>
        </Box>
      </Popover.Target>
      <Popover.Dropdown style={{ pointerEvents: 'none' }}>
        <Text fw={500}>{inquiry.customer.full_name}</Text>
        <Text c='dimmed' size='sm'>{inquiry.customer.email}</Text>
        <Text c='dimmed' size='sm'>
          {inquiry.customer.phone_number_country_code} {inquiry.customer.phone_number}
        </Text>
      </Popover.Dropdown>
    </Popover>
  )
}
